import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=cdade406&scoped=true&"
import script from "./PackageItem.vue?vue&type=script&lang=js&"
export * from "./PackageItem.vue?vue&type=script&lang=js&"
import style0 from "./PackageItem.vue?vue&type=style&index=0&id=cdade406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdade406",
  null
  
)

export default component.exports